module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/~/readable-stream/passthrough.js
// module id = 313
// module chunks = 0